import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)
